"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarkerSVGDraw = void 0;
var core_api_1 = require("@ikegps/core-api");
var __1 = require("../..");
var marker_drawable_1 = require("../../model/collection/drawable/marker.drawable");
var mithril_1 = require("../mithril");
var theme_1 = require("../theme");
var label_draw_svg_1 = require("./label.draw.svg");
var util_draw_svg_1 = require("./util.draw.svg");
var util_draw_svg_2 = require("./util.draw.svg");
var MARKER_CIRCLE_RADIUS = 6;
var MarkerSVGDraw = /** @class */ (function () {
    function MarkerSVGDraw() {
    }
    MarkerSVGDraw.view = function (node, options) {
        var _a, _b, _c;
        var currentState = node.state;
        if (!currentState) {
            return null;
        }
        // If the current element is an insight one, but we don't have the ability to view them, then don't render it.
        if (node.isInsightMeasurement) {
            if (!options.isInsightMarkersVisible) {
                return null;
            }
            if (!((_a = options.insightMarkerTypesVisible) !== null && _a !== void 0 ? _a : []).includes((_c = (_b = node.insight) === null || _b === void 0 ? void 0 : _b.detection_class) !== null && _c !== void 0 ? _c : '')) {
                return null;
            }
        }
        if (!node.isVisible) {
            return null;
        }
        var isSelected = options.draw.state.selectedId === currentState.id;
        var isHighlighted = options.draw.state.hoverId === currentState.id;
        var isMoveable = options.isInteractive && currentState.type !== core_api_1.MarkerType.BASE_OFFSET;
        var classNames = [
            theme_1.ClassNames.marker.container,
            currentState.type === core_api_1.MarkerType.BASE ? theme_1.ClassNames.marker.isBase : null,
            currentState.type === core_api_1.MarkerType.BASE_OFFSET ? theme_1.ClassNames.marker.isBaseOffset : null,
            isSelected ? theme_1.ClassNames.isSelected : null,
            isHighlighted ? theme_1.ClassNames.isHighlighted : null
        ];
        var pointClassNames = [
            isSelected ? theme_1.ClassNames.isSelected : null,
            isSelected ? theme_1.ClassNames.point.isSelected : null,
            isHighlighted ? theme_1.ClassNames.point.isHighlighted : null,
            isMoveable ? theme_1.ClassNames.isMoveable : null
        ];
        var markerPoint = { x: currentState.x, y: currentState.y };
        var startPoint = { x: currentState.x - options.draw.state.markerOffsetWidth, y: currentState.y };
        var endPoint = { x: currentState.x + options.draw.state.markerOffsetWidth, y: currentState.y };
        var output = [];
        var markerLabel = node.label;
        if (markerLabel != null) {
            var markerCircleOffset = options.draw.state.markerOffsetWidth;
            var markerLabelPoint = markerLabel.state;
            if (markerLabel.state.x < currentState.x) {
                markerCircleOffset = -options.draw.state.markerOffsetWidth;
                markerLabelPoint = {
                    x: markerLabelPoint.x + options.scale * label_draw_svg_1.LabelSVGDraw.Size.width - 5,
                    y: markerLabelPoint.y + options.scale * label_draw_svg_1.LabelSVGDraw.height(markerLabel.text.length) / 2
                };
            }
            else {
                markerLabelPoint = {
                    x: markerLabelPoint.x + 5,
                    y: markerLabelPoint.y + options.scale * label_draw_svg_1.LabelSVGDraw.height(markerLabel.text.length) / 2
                };
            }
            markerPoint.x += markerCircleOffset;
            output.push(util_draw_svg_1.SVGUtil.DrawLineMain(markerPoint, markerLabelPoint, options.scale));
            output.push(util_draw_svg_1.SVGUtil.DrawLineSecondary(markerPoint, markerLabelPoint, options.scale, node.isInsightMeasurement ? theme_1.StyleConfig.STOKE_SECONDARY_INSIGHT : theme_1.StyleConfig.STROKE_SECONDARY));
            output.push(util_draw_svg_1.SVGUtil.DrawLineMain(startPoint, endPoint, options.scale));
            output.push(util_draw_svg_1.SVGUtil.DrawLineSecondary(startPoint, endPoint, options.scale, node.isInsightMeasurement ? theme_1.StyleConfig.STOKE_SECONDARY_INSIGHT : theme_1.StyleConfig.STROKE_SECONDARY, isMoveable ? theme_1.ClassNames.isMoveable : null));
            if (options.isInteractive && !currentState.pair) {
                output.push(util_draw_svg_1.SVGUtil.DrawMoveLine(startPoint, endPoint, options.scale));
            }
            // open space markers
            if (options.isInteractive && currentState.pair) {
                if (options.isVerticalSeparationEnabled) {
                    output.push(util_draw_svg_1.SVGUtil.DrawMoveLine(startPoint, endPoint, options.scale));
                }
            }
            var verticalSeparationFields = node.label.links.filter(function (field) { return __1.CollectionModelFieldVerticalSeparation.isVerticalSeparationField(field); });
            // draw all vertical separations where the current marker is the top marker
            var separationsToDraw = verticalSeparationFields.filter(function (field) { return (field.hasValue()) && (field.drawableTop.id === node.id); }).sort(function (a, b) { return a.value - b.value; });
            var verticalSeparations = separationsToDraw.map(function (field, index) {
                var title = field.annotationLabel;
                var clearanceInMeters = options.isVerticalSeparationEnabled ? field.clearanceThresholdInMeters : undefined;
                var topMarkerPoint = field.drawableTop.getVector();
                var bottomMarkerPoint = field.drawableBottom.getVector();
                return label_draw_svg_1.LabelSVGDraw.verticalSeparation(markerLabel, options, topMarkerPoint, bottomMarkerPoint, title, index, clearanceInMeters);
            });
            if (verticalSeparations.length) {
                output.push.apply(output, verticalSeparations);
            }
            output.push(label_draw_svg_1.LabelSVGDraw.view(markerLabel, options));
        }
        // Styles for hover and select state
        if (options.isInteractive && (isSelected || isHighlighted)) {
            var pointFillColor = theme_1.StyleConfig.LABEL.FILL;
            var pointStrokeColor = theme_1.StyleConfig.LABEL.STROKE;
            if (node.isInsightMeasurement) {
                pointFillColor = theme_1.StyleConfig.LABEL.FILL_INSIGHT;
                if (isHighlighted) {
                    pointStrokeColor = theme_1.StyleConfig.LABEL.FILL_INSIGHT;
                }
                else {
                    pointStrokeColor = theme_1.StyleConfig.STROKE;
                }
            }
            else {
                pointFillColor = theme_1.StyleConfig.LABEL.FILL;
                if (isHighlighted) {
                    pointFillColor = theme_1.StyleConfig.LABEL.FILL_HIGHLIGHTED;
                }
                else if (isSelected) {
                    pointFillColor = theme_1.StyleConfig.LABEL.FILL_SELECTED;
                    pointStrokeColor = theme_1.StyleConfig.STROKE;
                }
            }
            var pointDraggable = currentState.type !== core_api_1.MarkerType.BASE_OFFSET;
            // normal user can't drag open space
            if (currentState.pair && !options.isVerticalSeparationEnabled) {
                pointDraggable = false;
            }
            var point = util_draw_svg_1.SVGUtil.DrawPoint(markerPoint, {
                className: pointClassNames.join(' '),
                radius: options.scale * MARKER_CIRCLE_RADIUS,
                scale: options.scale,
                fill: pointFillColor,
                stroke: pointStrokeColor,
                draggable: pointDraggable,
                label: currentState.type !== core_api_1.MarkerType.BASE_OFFSET ? util_draw_svg_2.IkeDrawLabel.POINT : null
            });
            output.push(point);
        }
        return (0, mithril_1.m)('g', {
            key: currentState.id,
            className: classNames.join(' '),
            'c-Draw-node-id': currentState.id,
            'c-Draw-tag': marker_drawable_1.CollectionModelDrawableMarker.TAG
        }, output);
    };
    return MarkerSVGDraw;
}());
exports.MarkerSVGDraw = MarkerSVGDraw;
//# sourceMappingURL=marker.draw.svg.js.map